import _ from 'lodash';

import { isInstanceOfCondition } from './ICondition';
import { isInstanceOfConditionGroup } from './IConditionGroup';
import { IMatcher } from './IMatcher';
import { MatchAnd } from './MatchAnd';
import { MatchAnswer } from './MatchAnswer';
import { MatchOr } from './MatchOr';

import { OptionRecord } from '../../types/models/user-management';

/**
 * Verify that the given @param objects is an array, and consist of ICondition or IConditionGroup object types.
 *
 * @param {any} objects Mix of ICondition and IConditionGroup objects
 * @return {boolean} True if the @param objects is an array, and consist of ICondition or IConditionGroup object types
 */
const isArrayOfConditionsAndConditionGroups = (objects: any): boolean =>
  Array.isArray(objects) && objects.every((obj) => isInstanceOfConditionGroup(obj) || isInstanceOfCondition(obj));

export class MatcherFactory {
  /**
   * Creates and returns the IMatcher object based on the @param when object data.
   *
   * @param {any} when The object containing the conditions and/or condition groups
   * @example
   * when = {...} as ICondition
   *
   * when = [{...}, {...}] as Array<ICondition | IConditionGroup>
   *
   * when = {
   *  and: [{...}, {...}]
   * } as IConditionGroup
   *
   * when = {
   *  or: [{
   *    and: [{...}, {...}]
   *  }, {
   *    and: [{...}, {...}]
   *  }]
   * } as IConditionGroup
   *
   * @return {IMatcher} The IMatcher instance
   */
  static create(when: any, lookupsData?: OptionRecord): IMatcher {
    const isConditionGroup = isInstanceOfConditionGroup(when);

    if (isArrayOfConditionsAndConditionGroups(when)) {
      return new MatchAnd(_.map(when, (w) => MatcherFactory.create(w, lookupsData)));
    } else if (isConditionGroup && _.has(when, 'and')) {
      return new MatchAnd(_.map(when.and, (w) => MatcherFactory.create(w, lookupsData)));
    } else if (isConditionGroup && _.has(when, 'or')) {
      return new MatchOr(_.map(when.or, (w) => MatcherFactory.create(w, lookupsData)));
    } else if (isInstanceOfCondition(when)) {
      return new MatchAnswer(when, lookupsData);
    } else {
      throw new Error('Unsupported object type');
    }
  }
}

export default MatcherFactory;
